import { GetStaticPaths } from 'next';
import {
  ProductPage,
  getStaticProps as getProps,
} from '../../../layout/product';
import { getProductsForPage } from '../../../data/page';
import { logForDebug } from '../../../utils/helpers';
import { getInitialShop } from 'data/shop';

export const getStaticProps = getProps;

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  const paths = [];
  const urls = [];
  const {
    shop: { buildPages },
  } = await getInitialShop('/', 'da');
  const products = await getProductsForPage('/');

  products.forEach((product) => {
    const mainVariant = (product.variants || []).find(
      (variant) => variant.type === 'main'
    );
    if (mainVariant) {
      mainVariant.attributes.forEach((attr) => {
        locales.forEach((locale) => {
          urls.push(`/${locale}/p/${product.slug}/${attr.sku.toLowerCase()}`);
          paths.push({
            params: {
              productSlug: product.slug,
              variantSku: attr.sku.toLowerCase(),
            },
            locale,
          });
        });
      });
    }
  });
  logForDebug((url) => console.log(`p/[productSlug]/[variantSku] => ${url}`));
  return {
    paths: buildPages ? urls : [], // urls,
    // paths: urls.splice(0, 150),
    // paths: [], // urls,
    // paths: urls,
    fallback: true,
  };
};
export default ProductPage;
